/**
 * Combines multiple ARIA ID references into a single space-separated string.
 * Filters out undefined, false, and empty string values.
 *
 * @param ids - Array of ID strings or falsy values
 * @returns Combined space-separated IDs or undefined if no valid IDs
 *
 * @example
 * combineIds('id1', 'id2', undefined) // 'id1 id2'
 * combineIds(undefined, false, '') // undefined
 * combineIds('id1', condition && 'id2') // 'id1' or 'id1 id2'
 */
export function combineIds(
  ...ids: (string | undefined | false)[]
): string | undefined {
  const validIds = ids.filter((id): id is string => Boolean(id));
  return validIds.length > 0 ? validIds.join(' ') : undefined;
}
